import { render, staticRenderFns } from "./assets_sidebar.vue?vue&type=template&id=0acbdd26&"
import script from "./assets_sidebar.vue?vue&type=script&lang=js&"
export * from "./assets_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports